/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useRef, useContext } from 'react';
import globals from '../../../../lib/globals/globals';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import useBrand from '../../../hooks/use-brand';
import IconButton from '../../../icon-button/IconButton';
import useStrings from '../../../hooks/use-strings';
import MagnifyingGlassIcon from '../icons/magnifying-glass/MagnifyingGlassIcon';
import WFMastheadContext from '../context/WFMastheadContext';
import styles from './Search.less';

var Search = function Search() {
  var formRef = useRef();

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  var searchLabel = getString('globalSearch.search');
  var brand = useBrand();

  var _useContext = useContext(WFMastheadContext),
      includeSearch = _useContext.includeSearch;

  var onClick = function onClick() {
    formRef.current.submit();
  };

  var classNames = getClasses({
    styles: styles,
    classes: ['search'],
    brand: brand
  });
  return includeSearch ? /*#__PURE__*/React.createElement("form", {
    action: globals().searchPublicUrl,
    method: "get",
    ref: formRef
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("input", {
    name: "q",
    type: "text",
    maxLength: 75,
    autoComplete: "off",
    autoCapitalize: "off",
    title: searchLabel,
    placeholder: searchLabel,
    "aria-label": searchLabel,
    alt: searchLabel
  }), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClick,
    ariaLabel: searchLabel,
    className: styles.icon
  }, /*#__PURE__*/React.createElement(MagnifyingGlassIcon, null)))) : null;
};

export default Search;